/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ listingName: NonNullable<unknown> }} Listingdeleteddesc2Inputs */

const en_listingdeleteddesc2 = /** @type {(inputs: Listingdeleteddesc2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The listing "${i?.listingName}" has been deleted successfully.`)
};

const de_listingdeleteddesc2 = /** @type {(inputs: Listingdeleteddesc2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.listingName}“ wurde gelöscht.`)
};

/**
* | output |
* | --- |
* | "The listing \"{listingName}\" has been deleted successfully." |
*
* @param {Listingdeleteddesc2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingdeleteddesc2 = /** @type {((inputs: Listingdeleteddesc2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingdeleteddesc2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingdeleteddesc2(inputs)
	return de_listingdeleteddesc2(inputs)
});
export { listingdeleteddesc2 as "listingDeletedDesc" }